import { AvatarProps, Breadcrumb, PageHeader, Row, Space } from "antd"
import { Route } from "antd/lib/breadcrumb/Breadcrumb"
import { ReactElement, ReactNode } from "react"
import { Link } from "react-router-dom"

type Props = {
    title: string|ReactElement,
    routes?: Route[],
    avatar?: AvatarProps,
    buttons?: ReactElement[],
    separator?: ReactNode,
    onBack?: any
}

/**
 * Page header with optional breadcrumbs and optional right aligned buttons
 * @param param0 
 * @returns 
 */
const CustomPageHeader: React.FC<Props> = ({ title, avatar = null, separator = "/", onBack = null, routes=null, buttons = [] }) => {

    /**
     * Bread crumb item render
     * @param route 
     * @param _ 
     * @param routes 
     * @returns 
     */
    const itemRender = (route, _, routes) => {
        if (routes.indexOf(route) === routes.length - 1)
            return <Breadcrumb.Item>{route.breadcrumbName}</Breadcrumb.Item>
        return <Link to={route.path}>{route.breadcrumbName}</Link>
    }

    return <>
        <Row justify="space-between" align="middle">
            <PageHeader title={title} avatar={avatar} onBack={onBack} breadcrumb={{ routes, itemRender, separator }} style={{padding: 0}}/>
            <Space className="custom-page-header-buttons">
                {buttons.map(b => b)}
            </Space>
        </Row>
    </>
}

export default CustomPageHeader;